import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useLazyScroll(loadMore, currResultLength, totalLength, t0, t1, t2) {
  const $ = _c(12);
  const cooldownMs = t0 === undefined ? 500 : t0;
  const triggerDistance = t1 === undefined ? 0 : t1;
  const progressDistance = t2 === undefined ? 50 : t2;
  const [isCoolDown, setIsCoolDown] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  let t3;
  let t4;
  if ($[0] !== cooldownMs || $[1] !== currResultLength || $[2] !== isCoolDown || $[3] !== loadMore || $[4] !== progressDistance || $[5] !== totalLength || $[6] !== triggerDistance) {
    t3 = () => {
      const handleScroll = () => {
        if (currResultLength === 0 || currResultLength === totalLength) {
          return;
        }
        const footer = document.getElementById("footer");
        if (!footer) {
          return;
        }
        const footerTop = footer.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;
        const distanceFromFooter = footerTop - viewportHeight;
        const clampedProgress = Math.max(0, Math.min(1, (progressDistance - distanceFromFooter) / progressDistance));
        setProgress(clampedProgress);
        if (distanceFromFooter <= triggerDistance && !isCoolDown) {
          setIsLoading(true);
          loadMore();
          setIsCoolDown(true);
          setTimeout(() => {
            setIsCoolDown(false);
            setIsLoading(false);
          }, cooldownMs);
        }
      };
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleScroll);
      handleScroll();
      return () => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleScroll);
      };
    };
    t4 = [loadMore, cooldownMs, triggerDistance, progressDistance, isCoolDown, currResultLength, totalLength];
    $[0] = cooldownMs;
    $[1] = currResultLength;
    $[2] = isCoolDown;
    $[3] = loadMore;
    $[4] = progressDistance;
    $[5] = totalLength;
    $[6] = triggerDistance;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== isLoading || $[10] !== progress) {
    t5 = [progress, isLoading];
    $[9] = isLoading;
    $[10] = progress;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}